<div class="addPrefecture" *ngIf="data.type === 'AddPrefecData'">
  <div *ngIf="!addPrefectureError && !addPrefectureSuccess">
    <form class="form" name="prefectureAddForm" [formGroup]="prefectureAddForm">

     

      <h1 mat-dialog-title>{{ "Add One Prefecture" | translate }}</h1>
      <!-- <mat-form-field>
        <input
          matInput
          name="addPrefecturesJP"
          placeholder="PrefecturesJP"
          [formControl]="addPrefecturesJPControl"
          [(ngModel)]="addPrefecturesJP"
        />
        <mat-error *ngIf="addPrefecturesJPControl.invalid">{{
          getPrefecErrorMessage(addPrefecturesJPControl)
        }}</mat-error>
      </mat-form-field> -->


      <mat-form-field>
      <input matInput name="PrefecturesJP" placeholder="PrefecturesJP" formControlName="addPrefecturesJP" />      
        
      <mat-error *ngIf=" getAddFormFieldsName('addPrefecturesJP').invalid && (getAddFormFieldsName('addPrefecturesJP').dirty || getAddFormFieldsName('addPrefecturesJP').touched)">
        <mat-error *ngIf="getAddFormFieldsName('addPrefecturesJP').hasError('required')">{{ getPrefecErrorMessage(prefectureAddForm.get('addPrefecturesJP')) }}</mat-error>
        <mat-error *ngIf="getAddFormFieldsName('addPrefecturesJP').hasError('pattern')">{{ 'Only Japanese Text Allowed' }}</mat-error>
      </mat-error>
      </mat-form-field>

      <!-- <mat-form-field>
        <input
          matInput
          name="addPrefecture"
          placeholder="Prefecture"
          [formControl]="addPrefectureControl"
          [(ngModel)]="addPrefecture"
        />
        <mat-error *ngIf="addPrefectureControl.invalid">
          {{ getPrefecErrorMessage(addPrefectureControl) }}</mat-error
        >
      </mat-form-field> -->

      <mat-form-field>
        <input matInput name="addPrefecture" placeholder="Prefecture" formControlName="addPrefecture" />          
        <mat-error *ngIf="getAddFormFieldsName('addPrefecture').hasError('required') || 
        getAddFormFieldsName('addPrefecture').hasError('pattern') ">
          {{ getPrefecErrorMessage(prefectureAddForm.get('addPrefecture')) }}       
        </mat-error>        
      </mat-form-field>


      <!-- <mat-form-field>
        <input
          matInput
          name="addRegion"
          placeholder="Region"
          [formControl]="addRegionControl"
          [(ngModel)]="addRegion"
        />
        <mat-error *ngIf="addRegionControl.invalid">{{
          getPrefecErrorMessage(addRegionControl)
        }}</mat-error>
      </mat-form-field> -->


      <mat-form-field>
        <input matInput name="addRegion" placeholder="Region" formControlName="addRegion" />      
        <mat-error *ngIf="getAddFormFieldsName('addRegion').hasError('required') || 
        getAddFormFieldsName('addRegion').hasError('pattern') ">
          {{ getPrefecErrorMessage(prefectureAddForm.get('addRegion')) }}       
        </mat-error>   
      </mat-form-field>


      <div mat-dialog-actions class="fileUploadActionButtons">
        <div>
          <button class="cancelButton" mat-button (click)="onNoClick()">
            {{ "Cancel" | translate }}
          </button>
          <button
            class="okButton"
            [disabled]="prefectureAddForm.invalid"
            mat-button
            (click)="confirmAdd(data.type)"
            cdkFocusInitial
          >
            Add
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="errorsList" *ngIf="addRackError && !addRackSuccess">
    <h1 class="errorHead" mat-dialog-title>{{ "Error Found" | translate }}</h1>
    <p class="errorDetails">{{ addPrefectureErrorMessage }}</p>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="addRackSuccess && !addRackError">
    <h1 mat-dialog-title>{{ "Addition Completed" | translate }}</h1>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="addPrefecture" *ngIf="data.type === 'EditPrefecData'">
  <div *ngIf="!editPrefectureError && !editPrefectureSuccess">
    <form
      class="form"
      name="prefectureEditForm"
      [formGroup]="prefectureEditForm"
    >
      <h1 mat-dialog-title>{{ "Edit Prefecture" | translate }}</h1>
      <mat-form-field>
        <input matInput name="editPrefecturesJP" placeholder="PrefecturesJP" formControlName="editPrefecturesJP" />       
        
        <mat-error *ngIf=" getFormFieldsName('editPrefecturesJP').invalid && (getFormFieldsName('editPrefecturesJP').dirty || getFormFieldsName('editPrefecturesJP').touched)">
          <mat-error *ngIf="getFormFieldsName('editPrefecturesJP').hasError('required')">{{ getPrefecErrorMessage(prefectureEditForm.get('editPrefecturesJP')) }}</mat-error>
          <mat-error *ngIf="getFormFieldsName('editPrefecturesJP').hasError('pattern')">{{ 'Only Japanese Text Allowed' }}</mat-error>
        </mat-error>
        
       
      </mat-form-field>
      
      <mat-form-field>
        <input matInput name="editPrefecture" placeholder="Prefecture" formControlName="editPrefecture" />          
        <mat-error *ngIf="getFormFieldsName('editPrefecture').hasError('required') || 
        getFormFieldsName('editPrefecture').hasError('pattern') ">
          {{ getPrefecErrorMessage(prefectureEditForm.get('editPrefecture')) }}       
        </mat-error>        
      </mat-form-field>
      
      <mat-form-field>
        <input matInput name="editRegion" placeholder="Region" formControlName="editRegion" />      
        <mat-error *ngIf="getFormFieldsName('editRegion').hasError('required') || 
                          getFormFieldsName('editRegion').hasError('pattern') ">
          {{ getPrefecErrorMessage(prefectureEditForm.get('editRegion')) }}       
        </mat-error>   
      </mat-form-field>

      <div mat-dialog-actions class="fileUploadActionButtons">
        <div>
          <button class="cancelButton" mat-button (click)="onNoClick()">
            {{ "Cancel" | translate }}
          </button>
          <button
            class="okButton"
            [disabled]="prefectureEditForm.invalid"
            mat-button
            cdkFocusInitial
            (click)="confirmAdd(data.type)"
          >
            Done
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="errorsList" *ngIf="editPrefectureError && !editPrefectureSuccess">
    <h1 class="errorHead" mat-dialog-title>{{ "Error Found" | translate }}</h1>
    <p class="errorDetails">{{ editPrefectureErrorMessage }}</p>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="editPrefectureSuccess && !editPrefectureError">
    <h1 mat-dialog-title>{{ "Prefecture edit Completed" | translate }}</h1>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="addPrefecture" *ngIf="data.type === 'DeletePrefecData'">
  <div *ngIf="!deletePrefectureError && !deletePrefectureSuccess">
    <h1 mat-dialog-title>Delete prefecture Information</h1>
    <p>Are you sure that you want to delete below prefecture.</p>
    <p>PrefecturesJP: {{ data.prefecData.prefecturesJP }}</p>
    <p>Prefecture: {{ data.prefecData.prefecture }}</p>
    <p>Region: {{ data.prefecData.region }}</p>
  </div>
  <div mat-dialog-actions class="fileUploadActionButtons">
    <div>
      <button class="cancelButton" mat-button (click)="onNoClick()">
        {{ "Cancel" | translate }}
      </button>
      <button
        class="okButton"
        mat-button
        cdkFocusInitial
        (click)="deletePrefecInformation(data.prefecData)"
      >
        {{ "Yes, Delete" | translate }}
      </button>
    </div>
  </div>
  <div
    class="errorsList"
    *ngIf="deletePrefectureError && !deletePrefectureSuccess"
  >
    <h1 class="errorHead" mat-dialog-title>{{ "Error Found" | translate }}</h1>
    <p class="errorDetails">{{ deletePrefectureErrorMessage }}</p>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="deletePrefectureSuccess && !deletePrefectureError">
    <h1 mat-dialog-title>{{ "Addition Completed" | translate }}</h1>
    <div mat-dialog-actions class="confirmedUploadAction">
      <button class="confirmCloseButton" mat-button (click)="onNoClick()">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
</div>
